/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb2niw_CtaInputs */

const en_visa_eb2niw_cta = /** @type {(inputs: Visa_Eb2niw_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn if you qualify for NIW`)
};

const pt_visa_eb2niw_cta = /** @type {(inputs: Visa_Eb2niw_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiba se você se qualifica para o NIW`)
};

const es_visa_eb2niw_cta = /** @type {(inputs: Visa_Eb2niw_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepa si califica para el NIW`)
};

/**
* | output |
* | --- |
* | "Learn if you qualify for NIW" |
*
* @param {Visa_Eb2niw_CtaInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb2niw_cta = /** @type {((inputs?: Visa_Eb2niw_CtaInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb2niw_CtaInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb2niw_cta(inputs)
	if (locale === "es") return es_visa_eb2niw_cta(inputs)
	return en_visa_eb2niw_cta(inputs)
});